import { Box, Button, Grid, Typography } from '@mui/material';

function InitialMessage({ showAvatar, setUserMessage, sendUserMessage }) {
  const handleClick = (text) => {
    sendUserMessage(text);
  };

  return (
    <Box
      sx={{
        pb: 2,
        minHeight: showAvatar ? '60vh' : '55vh', // or a fixed height like '300px' if needed
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        variant={showAvatar ? 'h4' : 'body1'}
        sx={{
          mb: 2,
          fontWeight: 600,
          color: '#333',
          textAlign: 'center',
        }}
      >
        What can I help you with?
      </Typography>
      <Grid container spacing={2}>
        {[
          // 'Load customer CSV from this path s3://dep-qa/inputs/Customer_1.csv, join with ticket data present at this path s3://dep-qa/inputs/support_tickets_updated.csv, keep only Indian customers, store in table called customer_360 in postgressql database: dep_Aws and schema is public.',
          'Create a workflow',
          'Describe my use case',
          'Report of use case',
          'Talk to workflow',
        ].map((text, index) => (
          <Grid item xs={6} key={index}>
            <Button
              fullWidth
              onClick={() => handleClick(text)}
              sx={{
                bgcolor: '#f1f1f1',
                color: '#000',
                textTransform: 'none',
                boxShadow: 1,
                height: '100%',
                padding: showAvatar ? '20px' : '8px',
                // fontSize: showAvatar ? '1rem' : '0.8rem',
                zIndex: 20,
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                },
              }}
            >
              {text}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default InitialMessage;
